import Model from "./base/model";

class TransporterCredential extends Model {
  resourceName() {
    return "transporter_credentials";
  }

  fields() {
    return {
      shipper_id: "",
      transporter_id: "",
      user: "",
      password: "",
      token: "",
      base_url: "",
      extra_integration_data: "",
      tms_type: "",
      shipper: { jsonApi: "hasOne", type: "shippers"},
      transporter: { jsonApi: "hasOne", type: "transporters"},
    };
  }

}

export default new TransporterCredential();
